import { useState } from "react";
import { truncate } from "../TruncatedText";

interface Props {
  text: string;
  expandable?: boolean;
  maxlength?: number;
}

export default function TextCollapse({
  text,
  expandable = true,
  maxlength = 180,
}: Props) {
  const [state, setState] = useState({ collapsed: true });
  const { collapsed } = state;
  const textToRender = collapsed ? truncate(text, maxlength) : text;
  const button = (
    <span
      style={{
        color: "#e72663d1",
        fontWeight: "bold",
        cursor: "pointer",
      }}
      onClick={() => setState({ collapsed: false })}
    >
      Read more
    </span>
  );

  const isLenghtier = text.length > textToRender.length;

  return (
    <>
      {textToRender} {expandable && collapsed && isLenghtier ? button : null}
    </>
  );
}
